import {mapMutations, mapGetters, mapActions} from "vuex";
import {pushFormGtmEvent} from "@/utils/formGtm";

export default {
    name: "product-comment",
    props: {},
    data() {
        return {
            payload: {
                message: '',
                product_id: '',
                stars: 0,
                guest_name: '',
            },
            errors: {
                guest_name: '',
                message: '',
            }
        }
    },
    watch: {
        'payload.guest_name'() { this.errors.guest_name = '' },
        'payload.message'() { this.errors.message = '' },
    },
    created() {
        this.payload.product_id = this.currentProduct.id
        if (this.questionId) {
            this.payload.parent_id = this.questionId
        }
    },
    computed: {
        ...mapGetters({
            currentProduct: 'catalog/currentProduct',
            questionId: 'card/questionId',
            isAuthenticated: 'auth/isAuthenticated',
        })
    },
    methods: {
        ...mapActions({
            sendQuestion: 'card/WRITE_COMMENT',
        }),
        ...mapMutations({
            closeCommentPopup: 'card/SHOW_COMMENT_POPUP',
        }),
        sendUserQuestion() {
            this.errors = { guest_name: '', message: '' }
            let hasError = false
            if (!this.isAuthenticated && !this.payload.guest_name.trim()) {
                this.errors.guest_name = "Введіть ваше ім'я"
                hasError = true
            }
            if (!this.payload.message.length) {
                this.errors.message = this.$t('callback.enterText')
                hasError = true
            } else if (this.payload.message.length <= 10) {
                this.errors.message = this.$t('validation.minLength', {'size': 10})
                hasError = true
            }
            if (!this.payload.stars && !this.questionId) {
                hasError = true
            }
            this.payload.stars = parseInt(this.payload.stars)
            if (!hasError) {
                const sendData = Object.assign({}, this.payload)
                if (this.questionId) {
                    delete sendData.stars
                }
                sendData.page_url = typeof window !== 'undefined' ? window.location.href : ''
                if (this.isAuthenticated) {
                    delete sendData.guest_name
                }
                this.sendQuestion(sendData).then(() => {
                    pushFormGtmEvent('comment_callback_form');
                    this.$toasted.success(this.$t('productCard.comments.success'));
                    this.closeCommentPopup(false)
                    document.getElementById('html').classList.remove('hide')
                }).catch(error => {
                    this.$toasted.error('error', error);
                })
            }
        }
    },
}
